module.exports = __webpack_public_path__ + "static/media/CC1.ad87406a.png";